import React, { useState } from 'react';
import { IconSemiArrowDown, getIcon } from '../../components/Icons';
import './DownloadableResources.scss';
import { ResourcesSelectProps } from '../../entities/Resource';

export default function ResourcesSelect({ resource }: ResourcesSelectProps): React.ReactElement {
  const [open, setOpen] = useState(false);
  return (
    <div className="resources-select" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <span className="resources__icon"> {getIcon(resource.icon)}</span>
      <div className="resources__text resources__text--multiple">{resource.name}</div>
      <button className="resources-select__arrow">
        <IconSemiArrowDown />
      </button>
      {/* Multiple Schematics */}
      {open && resource.multipleSchematics && (
        <div className="resources-select__accordion">
          {resource.multipleSchematics.map((item, i) => {
            const link = `${process.env.GATSBY_RESOURCES_URL}/schematics/` + item.node.base;
            const name = item.node.base.split('-')[1];
            return (
              <a key={item.node.base} href={link} target="_blank" rel="noreferrer" className="resources-select__link">
                {name}
              </a>
            );
          })}
        </div>
      )}
      {open && resource.multipleDatascheets && (
        <div className="resources__accordion">
          <p>Multiple Datascheets</p>
        </div>
      )}
    </div>
  );
}
